import { gql } from '@apollo/client';
import { Col, Form, Input, Row, Select } from 'antd';
import { FormattedMessage } from 'react-intl';
import SettingsDrawer from 'components/Settings/SettingsDrawer';
import { useMutation } from 'hooks/apollo';
import React, { useEffect, useState } from 'react';
import { MODULE_LICENSE_SETTINGS } from 'shared/constants/settings';
import { LicenseStatus, Module } from 'shared/prisma/types';
import globalMessages from 'translations/messages';
import NumberInput from 'components/NumberInput';

const UPDATE_LICENSE = gql`
  mutation UpdateModuleLicense($id: ID!, $input: ModuleLicenseInput!) {
    updateModuleLicense(id: $id, input: $input) {
      id
      title
      uniqueTitle
      status
      level
      module
    }
  }
`;

const CREATE_LICENSE = gql`
  mutation CreateModuleLicense($input: ModuleLicenseInput!) {
    createModuleLicense(input: $input) {
      id
      title
      uniqueTitle
      status
      level
      module
    }
  }
`;

const getModuleSettings = module => MODULE_LICENSE_SETTINGS[module];

const EditModuleLicenseDrawer = ({ license, onDone, onCreate }) => {
  const [updateLicense] = useMutation(UPDATE_LICENSE);
  const [createLicense] = useMutation(CREATE_LICENSE);
  const [moduleSettings, setModuleSettings] = useState();

  useEffect(() => {
    if (license) {
      setModuleSettings(getModuleSettings(license.module));
    }
  }, [license]);

  const onSubmit = async (values) => {
    let { id } = license;
    if (id) {
      await updateLicense({ variables: { id, input: values } });
    } else {
      const res = await createLicense({ variables: { input: values } });
      id = res.data.createModuleLicense.id;
      onCreate();
    }

    return id;
  };

  return (
    <SettingsDrawer
      title="Edit license details"
      settings={moduleSettings}
      initialValues={license}
      relationId={license?.id}
      open={!!license}
      onDone={onDone}
      onCancel={onDone}
      onSubmit={onSubmit}
    >
      <Form.Item name="title" label="Display title" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="uniqueTitle" label="Internal title">
        <Input />
      </Form.Item>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="module" label="Module" rules={[{ required: true }]}>
            <Select options={Object.values(Module).map(s => ({ label: <FormattedMessage {...globalMessages[s]} />, value: s }))} onChange={value => setModuleSettings(getModuleSettings(value))} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="status" label="Status" rules={[{ required: true }]}>
            <Select options={Object.values(LicenseStatus).map(s => ({ label: <FormattedMessage {...globalMessages[s]} />, value: s }))} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="level" label="Level" rules={[{ required: true }]}>
            <NumberInput />
          </Form.Item>
        </Col>
      </Row>
    </SettingsDrawer>
  );
};

export default EditModuleLicenseDrawer;
